import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';
import { useAuthContext } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  const { user } = useAuthContext();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (!user?.isAdmin) {
    const allowed = ['/', '/clientes', '/apolices'];
    const isApoliceEdit = location.pathname.startsWith('/apolices/editar/');
    if (!allowed.includes(location.pathname) && !isApoliceEdit) {
      return <Navigate to="/clientes" />;
    }
  }

  return <>{children}</>;
};

export default PrivateRoute; 